import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '爆料热榜', href: '#ranking' },
  { label: '平台优势', href: '#features' },
  { label: '关于黑料', href: '#about' },
  { label: '专题合集', href: '#index' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeNav, setActiveNav] = useState('#hero');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setActiveNav(href);
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 no-underline"
        >
          <span className="font-heading text-2xl font-bold text-primary-600 tracking-wide">
            黑料
          </span>
          <span className="hidden sm:inline-block text-xs text-foreground-500 font-label bg-background-100 px-2 py-0.5 rounded-full">
            每日吃瓜
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-label transition-all duration-200 cursor-pointer ${
                activeNav === item.href
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#app"
            onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
            className="whitespace-nowrap px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-label hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-download-line mr-1.5"></i>
            下载App
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`whitespace-nowrap px-4 py-3 rounded-lg text-sm font-label transition-all duration-200 cursor-pointer ${
                  activeNav === item.href
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="whitespace-nowrap px-4 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-label text-center cursor-pointer"
            >
              <i className="ri-download-line mr-1.5"></i>下载App
            </a>
          </div>
        </div>
      )}
    </header>
  );
}